import React, { createContext, useContext, useState, useMemo } from "react";

const AdminContext = createContext(null);

export function AdminProvider({ children }) {
    const [community, setCommunity] = useState("ALL"); // ALL or community key
    const value = useMemo(() => ({ community, setCommunity }), [community]);
    return <AdminContext.Provider value={value}>{children}</AdminContext.Provider>;
}

export const useAdmin = () => useContext(AdminContext);
